import { ReactElement } from 'react';
import { useTheme } from 'styled-components';

import { ServiceLocationId } from '@dreryk/egabinet-healthcare-provider-published-language-api';

import { Message, MessageOptions } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

const useOptions = (): MessageOptions<{ INCOMPATIBLE: 'INCOMPATIBLE' }> => {
   const theme = useTheme();
   return {
      INCOMPATIBLE: {
         color: theme.warning,
         backgroundColor: theme.warningLighter,
      },
   };
};

type ServiceNotAvailableInLocationStatusProps = {
   currentServiceLocationIds: ServiceLocationId[];
   currentLocationId: ServiceLocationId;
};

export const ServiceNotAvailableInLocationStatus = (
   props: ServiceNotAvailableInLocationStatusProps
): ReactElement | null => {
   const options = useOptions();
   const shouldDisplayWarning =
      props.currentServiceLocationIds.length &&
      props.currentServiceLocationIds.every(
         (serviceLocationId) => serviceLocationId.asString() !== props.currentLocationId.asString()
      );

   if (!shouldDisplayWarning) {
      return null;
   }

   return (
      <Message
         testId={'serviceNotAvailableInLocation'}
         type={'INCOMPATIBLE'}
         options={options}
         displayIndicator
         label={translationKeys.selectedServiceIsNotPerfomedWithingLocation}
      />
   );
};
